import DatePickerWrapper from '@gp/components/DatePickerWrapper';
import { MilestoneDateStatus } from '@gp/enums/milestone';
import Switch from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/MilestoneTBCSwitch';
import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import { DatePicker } from 'tea-component';

import type { IDynamicFormControlValueAccessor } from '@gp/components/DynamicForm/components/FormControl/types';
import type { IBaseProps } from '@home/types/common';

import './index.scss';

const { MonthPicker } = DatePicker;

export interface ITBCDatePickerValue {
  // TBC
  dateConfirm: MilestoneDateStatus;
  // 日期，格式YYYY-MM-DD，日粒度精确到日，月粒度为当月最后一天的日期
  date: string;
}

interface ITBCDatePickerProps
  extends IBaseProps,
    IDynamicFormControlValueAccessor<ITBCDatePickerValue> {
  onTBCChange?: (payload: MilestoneDateStatus) => void;
  onDateChange?: (payload: string) => void;
}

const TBCDatePicker: React.FC<ITBCDatePickerProps> = (props) => {
  const { style, className, value, onChange, onTBCChange, onDateChange } = props;

  const { dateConfirm, date } = value || {};

  const handleDateMonthChange = (date: string) => {
    const valueTmp = { ...value, date };
    onChange?.(valueTmp);
    onDateChange?.(date);
  };

  return (
    <div style={style} className={classnames('dbg-milestone-tbc-date-picker', className)}>
      <div className="dbg-milestone-add-switch-span-pa-div">
        <span className="dbg-milestone-add-switch-span">Time is an estimate (TBC)</span>
        <Switch
          value={dateConfirm}
          onChange={(payload) => {
            const valueTmp = { ...value, dateConfirm: payload };
            if (payload === MilestoneDateStatus.ToBeConfirm && date) {
              valueTmp.date = moment(date).endOf('month').format('YYYY-MM-DD');
            }
            onChange?.(valueTmp);
            onTBCChange?.(payload);
          }}
        ></Switch>
      </div>
      <span className="dbg-milestone-tbc-date-picker__splitter">-</span>
      <div>
        {dateConfirm === MilestoneDateStatus.Confirm && (
          <DatePickerWrapper className={classnames({ 'dbg-is-error': !date })} label="Day">
            <DatePicker
              placeholder="Select Date"
              value={date ? moment(date) : undefined}
              onChange={(payload) => {
                const dateTmp = payload?.format('YYYY-MM-DD') || '';
                handleDateMonthChange(dateTmp);
              }}
            />
          </DatePickerWrapper>
        )}
        {dateConfirm === MilestoneDateStatus.ToBeConfirm && (
          <DatePickerWrapper className={classnames({ 'dbg-is-error': !date })} label="Month">
            <MonthPicker
              placeholder="Select Month"
              value={date ? moment(date) : undefined}
              onChange={(payload) => {
                const dateTmp = payload?.endOf('month')?.format('YYYY-MM-DD') || '';
                handleDateMonthChange(dateTmp);
              }}
            />
          </DatePickerWrapper>
        )}
      </div>
    </div>
  );
};

export default TBCDatePicker;
